import type { SpellCheckHandler } from '@/teoCore/text/SpellCheckHandler';
import type { PillGroup } from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';

export type SpellCheckPillGroup = Omit<PillGroup, 'key'> & { key: string };

export function createPillGroups(scHandler: SpellCheckHandler): SpellCheckPillGroup[] {
  const spellCheckGroups: SpellCheckPillGroup[] = [
    {
      id: '0',
      key: 'suggestedcorrections',
      label: 'Korrekturvorschläge',
      score: undefined,
      used: true,
      pills: [],
    },
  ];
  let spellingCount = 0;
  let grammarCount = 0;
  for (const match of scHandler.currentMatches) {
    if (match.variant === 'spelling') {
      spellingCount += 1;
    } else if (match.variant === 'grammar') {
      grammarCount += 1;
    }
  }

  spellCheckGroups[0]?.pills.push(
    {
      id: '0',
      key: 'spelling',
      type: 'MarkerPillData',
      label: 'Rechtschreibung',
      value: spellingCount,
    },
    {
      id: '1',
      key: 'grammar',
      type: 'MarkerPillData',
      label: 'Grammatik',
      value: grammarCount,
    },
  );

  return spellCheckGroups;
}
